import { render } from "./ColorsInput.vue?vue&type=template&id=271b9223"
import script from "./ColorsInput.vue?vue&type=script&lang=js"
export * from "./ColorsInput.vue?vue&type=script&lang=js"

import "./ColorsInput.vue?vue&type=style&index=0&id=271b9223&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__